'use strict';

import React from 'react';
import bemit from 'Functions/bemit';
import { days_config } from 'Shared/options';
import { isTrue } from 'Shared/utilities';
const {
  app,
  moment
} = window;
export default function CoworkingSchedule(props) {
  const {
    space,
    date,
    schedule = {}
  } = props;
  moment.locale('fr');
  const en_name = days_config[moment(date).isoWeekday() - 1]; // [1 to 7 -1]

  const day_schedule = schedule[en_name] || {};
  let output,
    col_class = 'c-coworking-space__price__row__col';
  const is__sunday = moment(date).isoWeekday() === 7;
  let col_modifiers = [],
    open_modifiers = [];
  if (is__sunday) col_modifiers.push('weekend');
  const availability = space.availabilities?.[date];
  if (space.type === 'a_calm_coworking_space') {
    const is__closed_in_space = !isTrue(day_schedule.open);
    const is__closed = availability === 'close' || is__closed_in_space && availability !== 'open';
    const is__manual = ['close', 'open'].includes(availability);
    open_modifiers.push(is__closed ? 'closed' : 'open');
    if (is__manual) open_modifiers.push('manual');
    output = /*#__PURE__*/React.createElement("div", {
      className: bemit(col_class, col_modifiers)
    }, /*#__PURE__*/React.createElement("span", {
      className: bemit('c-open-date', open_modifiers)
    }, is__closed ? 'Fermé' : 'Ouvert'));
    return output;
  }
  col_modifiers.push('seminar');
  const morning_modifiers = open_modifiers.slice(0);
  const afternoon_modifiers = open_modifiers.slice(0);
  const morning_manual = ['close', 'open'].includes(availability?.morning);
  const afternoon_manual = ['close', 'open'].includes(availability?.afternoon);
  if (morning_manual) morning_modifiers.push('manual');
  if (afternoon_manual) afternoon_modifiers.push('manual');
  const morning_closed_in_space = !isTrue(day_schedule.morning);
  const afternoon_closed_in_space = !isTrue(day_schedule.afternoon);
  const morning_closed = availability?.morning === 'close' || morning_closed_in_space && availability?.morning !== 'open';
  morning_modifiers.push(morning_closed ? 'closed' : 'open');
  const afternoon_closed = availability?.afternoon === 'close' || afternoon_closed_in_space && availability?.afternoon !== 'open';
  afternoon_modifiers.push(afternoon_closed ? 'closed' : 'open');
  output = /*#__PURE__*/React.createElement("div", {
    className: bemit(col_class, col_modifiers)
  }, /*#__PURE__*/React.createElement("span", {
    className: bemit('c-open-date', morning_modifiers)
  }, morning_closed ? 'Fermé' : 'Ouvert'), /*#__PURE__*/React.createElement("span", {
    className: bemit('c-open-date', afternoon_modifiers)
  }, afternoon_closed ? 'Fermé' : 'Ouvert'));
  return output;
}
